<div class="{{styleBreadcrumb}}">
  <div class="row">
    <div [ngClass]="{'col-10': isFhir && isShowHome, 'col-12': !(isFhir && isShowHome)}">
      <h1><i *ngIf="icon" class="fal {{icon}} mr-3" style="color: white"></i>{{title}}
        <i *ngIf="breadcrumb" class="fal fa-angle-right"></i>
        <span *ngIf="isStringLiteral && breadcrumb">&nbsp;{{ breadcrumb }}&nbsp;</span>
        <span *ngIf="!isStringLiteral && breadcrumb">&nbsp;{{ breadcrumb | translate }}&nbsp;</span>
        <span *ngIf="dob" class="date-of-birth">{{dob | date}} ({{'AGE' | translate}} {{ dob | age }})</span>
        <span *ngIf="count" class="badge badge-pill badge-secondary ml-2"
          [ngStyle]="{'background-color': countBgColor}"><span class="count">{{count}}</span></span>
      </h1>
    </div>
    <div *ngIf="isFhir && isShowHome" class="col-2 text-right" style="margin-top:20px">
      <button class="btn btn-outline-light mr-4" (click)="openFullSite()">
        {{ 'OPEN-FULL-SITE' | translate }}
        <i class="arrow fal fa-external-link"></i>
      </button>
    </div>
  </div>
</div>